<template>
    <a v-else  dusk="logout" @click="logout">
        {{ $lang('app.logout') }}
    </a>
</template>

<script>
import ApiService from "../../api/api";

export default {
    name: 'HeaderLogoutButton',
    methods: {
        logout() {
            this.$loading(this.$optionsLoading);

            ApiService.post('/logout').then(() => {
                return location.href = window.laravel.prefix + '/';
            }).finally(() => this.$loading({}).close());
        }
    }
}
</script>
